import React, { FC } from 'react';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { NumericMenu } from 'react-instantsearch-dom';

import { FilterWrapper } from '../FilterWrapper';
import useStyles from '../FiltersPanel/styles';
import { HierarchicalMenu as CustomHierarchicalMenu } from '../HierarchicalMenu';
import { RefinementList as CustomRefinementList } from '../RefinementList';

const expertNumericMenuItems = [{ label: 'videos-exist', start: 1 }];

interface ExpertsFilterPanelProps {
  tenantName?: string | null;
}

const ExpertsFilterPanel: FC<ExpertsFilterPanelProps> = ({ tenantName }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.filtersPanel}>
      <FilterWrapper title={t('page.discover.categories')}>
        <CustomHierarchicalMenu attributes={['categories.lvl0', 'categories.lvl1']} />
      </FilterWrapper>
      <CustomRefinementList attribute="tenants" hidden />
      {/*filter experts with at least 1 video on tenant*/}
      <div className={classes.videosCountFilterWrapper}>
        <NumericMenu
          attribute={`videos_count.${tenantName}`}
          items={expertNumericMenuItems}
          defaultRefinement="1:"
        />
      </div>
    </Box>
  );
};

export default ExpertsFilterPanel;
